import React, { Component, Fragment } from 'react'
import { Trans } from '@lingui/react'
import RecurrentSubscriptionCardBox from 'client/bookmate/boxes/recurrent-subscription-card-box'
import { ProductCardHorizontal } from 'client/bookmate/blocks/product-card'
import NonRecurrentSubscriptionCard from 'client/bookmate/blocks/non-recurrent-subscription-card'
import Spacer from 'client/shared/blocks/spacer'
import { Heading } from 'client/shared/blocks/heading'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import {
  CurrentUserSubscriptions,
  Product,
} from 'client/shared/types/subscription'
import urlHelper, { QueryParams } from 'shared/tools/url-helper'
import Button from 'client/shared/blocks/button/button'
import { Dispatch } from 'shared/types/redux'
import './manage-subscriptions.styl'
import { Loader } from 'client/shared/blocks/loader/loader'

type Props = {
  userSubscriptions: CurrentUserSubscriptions
  products: Product[]
  country: string
  query?: QueryParams
  dispatch: Dispatch
  haveUserSubscriptionsLoaded: boolean
}

type State = {
  isRetentionOfferShown: boolean
  isCancellationNoticeShow: boolean
}

export const MANAGE_HEAD_TITLE_ID = 'subscription-head_title'

export class ManageSubscriptions extends Component<Props, State> {
  state = {
    isRetentionOfferShown: false,
    isCancellationNoticeShow: false,
  }
  render(): JSX.Element {
    const isGhana = this.props.userSubscriptions.recurrents.find(
      item => item.system === 'mtn_ghana',
    )
    return (
      <LayoutColumn>
        <div className="manage-subscriptions">
          <Spacer size="top-page" />
          <Heading id={MANAGE_HEAD_TITLE_ID}>
            <Trans id="subscription.head_title" />
          </Heading>
          <Spacer size="after-heading" />
          {!this.props.haveUserSubscriptionsLoaded ? (
            <Loader color="gray" kind="big" centered />
          ) : (
            this.renderActiveSubscriptions()
          )}
          {Boolean(isGhana) && (
            <>
              <Spacer size={40} />
              <Button kind="transparent" path={urlHelper.mtnPage()}>
                Join Now and Start Reading!
              </Button>
              <Spacer size={24} />
            </>
          )}
          {this.renderProducts()}
        </div>
        <Spacer size="bottom-page" />
      </LayoutColumn>
    )
  }

  toggleRetentionOffer(): void {
    this.setState({
      isRetentionOfferShown: !this.state.isRetentionOfferShown,
      isCancellationNoticeShow: false,
    })
  }

  toggleCancellationOffer(): void {
    this.setState({
      isCancellationNoticeShow: !this.state.isCancellationNoticeShow,
    })
  }

  renderActiveSubscriptions(): JSX.Element | null {
    const { userSubscriptions } = this.props
    const activeSubscriptions = [
      ...userSubscriptions.recurrents,
      ...userSubscriptions.non_recurrents,
    ]
    if (!activeSubscriptions.length) return null

    return (
      <Fragment>
        {this.state.isRetentionOfferShown ? null : (
          <>
            <Heading rank={2}>
              <Trans
                id={`subscription.${
                  this.state.isCancellationNoticeShow
                    ? 'cancel_subscription'
                    : 'active_subscriptions'
                }`}
              />
            </Heading>
            <Spacer size={24} />
          </>
        )}
        {this.renderSubscriptionCards()}
      </Fragment>
    )
  }

  renderSubscriptionCards(): JSX.Element {
    return (
      <div className="manage-subscriptions__subscription-cards">
        {this.renderRecurrentSubscriptionCards()}
        {this.renderNonRecurrentSubscriptionCards()}
      </div>
    )
  }

  renderRecurrentSubscriptionCards(): JSX.Element[] {
    return this.props.userSubscriptions.recurrents.map(
      (subscription, index) => (
        <RecurrentSubscriptionCardBox
          toggleCancellationOffer={this.toggleCancellationOffer.bind(this)}
          showRetentionOffer={this.toggleRetentionOffer.bind(this)}
          key={index}
          subscription={subscription}
        />
      ),
    )
  }
  renderNonRecurrentSubscriptionCards(): JSX.Element[] {
    return this.props.userSubscriptions.non_recurrents.map(
      (subscription, index) => (
        <NonRecurrentSubscriptionCard key={index} subscription={subscription} />
      ),
    )
  }

  renderProducts(): JSX.Element | null {
    const { products, query } = this.props
    if (!products.length) return null

    return (
      <Fragment>
        <Spacer size={40} />
        <Heading rank={2}>
          <Trans id="subscription.other_subscriptions" />
        </Heading>
        <Spacer size={24} />
        {products.map(product => (
          <ProductCardHorizontal
            query={query}
            product={product}
            key={product.id}
          />
        ))}
      </Fragment>
    )
  }
}
